import { CSSProperties, PropsWithChildren, ReactElement } from 'react'

import { Button } from 'antd'
import noop from 'lodash/noop'

import { Icon } from 'components/core'

interface CreateResourceButtonProps {
    icon?: ReactElement | null
    onClick?: () => void
    loading?: boolean
    className?: string
    disabled?: boolean
    style?: CSSProperties
    ghost?: boolean
}

function CreateResourceButton({
    icon = <Icon name="PLUS" />,
    onClick = noop,
    loading = false,
    children = null,
    className = '',
    ...props
}: PropsWithChildren<CreateResourceButtonProps>): ReactElement {
    return (
        <Button
            type="primary"
            icon={icon}
            onClick={onClick}
            loading={loading}
            className={className}
            {...props}
        >
            {children}
        </Button>
    )
}

export default CreateResourceButton
